import Build from '@material-ui/icons/Build';
import Info from '@material-ui/icons/Info';
import Warning from '@material-ui/icons/Warning';
import Help from '@material-ui/icons/Help';
import Description from '@material-ui/icons/Description';
import Assignment from '@material-ui/icons/Assignment';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import SettingsIcon from '@material-ui/icons/Settings';
import Star from '@material-ui/icons/Star';
import Favorite from '@material-ui/icons/Favorite';
import Notifications from '@material-ui/icons/Notifications';
import Schedule from '@material-ui/icons/Schedule';
import Computer from '@material-ui/icons/Computer';
import PhoneAndroid from '@material-ui/icons/PhoneAndroid';
import Storage from '@material-ui/icons/Storage';
import BarChart from '@material-ui/icons/BarChart';
import ContactPhone from '@material-ui/icons/ContactPhone';
import LocationOn from '@material-ui/icons/LocationOn';
import Print from '@material-ui/icons/Print';
import Folder from '@material-ui/icons/Folder';
import Link from '@material-ui/icons/Link';
import Search from '@material-ui/icons/Search';
import Home from '@material-ui/icons/Home';
import Person from '@material-ui/icons/Person';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Error from '@material-ui/icons/Error';
import EuroSymbol from '@material-ui/icons/EuroSymbol';
import Timeline from '@material-ui/icons/Timeline';
import Image from '@material-ui/icons/Image';
import Book from '@material-ui/icons/Book';

export const ICON_MAP = {
    Build,
    Info,
    Warning,
    Help,
    Description,
    Assignment,
    PhotoCamera,
    Settings: SettingsIcon,
    Star,
    Favorite,
    Notifications,
    Schedule,
    Computer,
    PhoneAndroid,
    Storage,
    BarChart,
    ContactPhone,
    LocationOn,
    Print,
    Folder,
    Link,
    Search,
    Home,
    Person,
    CheckCircle,
    Error,
    EuroSymbol,
    Timeline,
    Image,
    Book,
};

export const ICON_OPTIONS = [
    { name: 'Build', label: 'Herramientas' },
    { name: 'Info', label: 'Información' },
    { name: 'Warning', label: 'Aviso' },
    { name: 'Help', label: 'Ayuda' },
    { name: 'Description', label: 'Documento' },
    { name: 'Assignment', label: 'Tarea' },
    { name: 'PhotoCamera', label: 'Cámara' },
    { name: 'Settings', label: 'Configuración' },
    { name: 'Star', label: 'Estrella' },
    { name: 'Favorite', label: 'Favorito' },
    { name: 'Notifications', label: 'Notificaciones' },
    { name: 'Schedule', label: 'Horario' },
    { name: 'Computer', label: 'Ordenador' },
    { name: 'PhoneAndroid', label: 'Móvil' },
    { name: 'Storage', label: 'Almacenamiento' },
    { name: 'BarChart', label: 'Gráfico' },
    { name: 'ContactPhone', label: 'Contacto' },
    { name: 'LocationOn', label: 'Ubicación' },
    { name: 'Print', label: 'Imprimir' },
    { name: 'Folder', label: 'Carpeta' },
    { name: 'Link', label: 'Enlace' },
    { name: 'Search', label: 'Buscar' },
    { name: 'Home', label: 'Inicio' },
    { name: 'Person', label: 'Persona' },
    { name: 'CheckCircle', label: 'OK' },
    { name: 'Error', label: 'Error' },
    { name: 'EuroSymbol', label: 'Euro' },
    { name: 'Timeline', label: 'Línea de tiempo' },
    { name: 'Image', label: 'Imagen' },
    { name: 'Book', label: 'Libro' },
];
